import React, { useState } from 'react';

const InputStep = ({ question, value, onAnswer, onNext }) => {
  const [inputValue, setInputValue] = useState(value || '');
  const [error, setError] = useState('');

  const handleChange = (e) => {
    let val = e.target.value;
    
    // Handle number type
    if (question.type === 'number') {
      val = val.replace(/[^0-9.]/g, '');
    }
    
    setInputValue(val);
    setError('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validation
    if (!inputValue.trim()) {
      setError('This field is required');
      return;
    }

    if (question.validation) {
      if (question.validation.min && Number(inputValue) < question.validation.min) {
        setError(`Minimum value is ${question.validation.min}`);
        return;
      }
      if (question.validation.max && Number(inputValue) > question.validation.max) {
        setError(`Maximum value is ${question.validation.max}`);
        return;
      }
    }

    onAnswer(inputValue);
    onNext();
  };

  return (
    <div data-testid={`step-${question.id}`}>
      {/* Question */}
      <h2 className="text-2xl md:text-3xl font-semibold text-center text-gray-900 mb-2">
        {question.question}
      </h2>

      {/* Subtitle */}
      {question.subtitle && (
        <p className="text-center text-gray-500 mb-8">
          {question.subtitle}
        </p>
      )}

      {/* Form */}
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <input
            type={question.inputType || 'text'}
            value={inputValue}
            onChange={handleChange}
            placeholder={question.placeholder || ''}
            className={`form-input text-center text-lg ${error ? 'error' : ''}`}
            autoFocus
            data-testid="input-field"
          />
          {question.unit && (
            <p className="text-center text-gray-500 mt-2">{question.unit}</p>
          )}
          {error && (
            <p className="text-center text-red-500 text-sm mt-2" data-testid="error-message">
              {error}
            </p>
          )}
        </div>

        <button
          type="submit"
          className="btn-primary"
          data-testid="continue-button"
        >
          Continue
        </button>
      </form>
    </div>
  );
};

export default InputStep;
